"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var faRankingStar_1 = require("@fortawesome/free-solid-svg-icons/faRankingStar");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var MenuPopButton_1 = __importDefault(require("../Menu/MenuPopButton"));
function ResultPopButton(props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var gameOver = (0, react_redux_1.useSelector)(function (state) { return state.gameOver; });
    return ((0, jsx_runtime_1.jsx)(MenuPopButton_1.default, __assign({ pop: gameOver, css: style, title: t('result.button') }, props, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faRankingStar_1.faRankingStar, css: shakeAnimation }) })));
}
exports.default = ResultPopButton;
var style = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: white;\n  color: #28b8ce;\n\n  &:focus, &:hover {\n    background: #f0fbfc;\n  }\n\n  &:active {\n    background: #dbf5f8;\n  }\n"], ["\n  background: white;\n  color: #28b8ce;\n\n  &:focus, &:hover {\n    background: #f0fbfc;\n  }\n\n  &:active {\n    background: #dbf5f8;\n  }\n"])));
var shake = (0, react_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  1%, 9% {\n    transform: translate(-1px, 0);\n  }\n\n  2%, 8% {\n    transform: translate(2px, 0);\n  }\n\n  3%, 5%, 7% {\n    transform: translate(-4px, 0);\n  }\n\n  4%, 6% {\n    transform: translate(4px, 0);\n  }\n  10%, 100% {\n    transform: none;\n  }\n"], ["\n  1%, 9% {\n    transform: translate(-1px, 0);\n  }\n\n  2%, 8% {\n    transform: translate(2px, 0);\n  }\n\n  3%, 5%, 7% {\n    transform: translate(-4px, 0);\n  }\n\n  4%, 6% {\n    transform: translate(4px, 0);\n  }\n  10%, 100% {\n    transform: none;\n  }\n"])));
var shakeAnimation = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 1s alternate infinite;\n"], ["\n  animation: ", " 1s alternate infinite;\n"])), shake);
var templateObject_1, templateObject_2, templateObject_3;
